<template>
  <h1>New Project</h1>

  <div class="container">
    <MyForm :title="'New Project:'">
      <template v-slot:fields>
        <!--Form-input v-model="projectInfo.source" :name="'source:'"></Form-input-->
        <!--Form-input v-model="projectInfo.division" :name="'Division:'"></Form-input-->
        <p class="debug">project create: division = {{ projectInfo.division }}</p>
        <Project-division v-model:selected="projectInfo.division"></Project-division>
        <!--Project-source v-model:selected="projectInfo.source"></Project-source-->
        <p class="debug">owner_id : {{projectInfo.owner_id}}</p>
        <p class="debug">owner : {{projectInfo.owner}}</p>
        <UserSelect
          v-model:selected="projectInfo.owner_id"
          :name="'Owner:'"
          :role="'owner'"
          :includeArchived="false"
        ></UserSelect>
        <UserSelect
          v-model:selected="projectInfo.engineer_id"
          :name="'Engineer:'"
          :role="'engineer'"
          :includeArchived="false"
        ></UserSelect>
        <UserSelect
          v-model:selected="projectInfo.drafter_id"
          :name="'Drafter:'"
          :role="'drafter'"
          :includeArchived="false"
        ></UserSelect>
        <Form-input v-model="projectInfo.description" :name="'description:'"></Form-input>
        <!--CustomerSelect v-model:selected="projectInfo.customerId"></CustomerSelect-->
        <CustomerListbox v-model:customer="projectInfo.customer" :newProject=true></CustomerListbox>
        <!--CustomerNew v-model:selected="projectInfo.customer"></CustomerNew>"-->
        <FormTextArea v-model="projectInfo.notes" :name="'notes:'"></FormTextArea>
        <Project-location
          :projectName="'New Project'"
          v-model:streetAddress="projectInfo.streetAddress"
          v-model:city="projectInfo.city"
          v-model:province="projectInfo.province"
          v-model:gps="projectInfo.gps"
          @updateGPS="reloadLocation"
          :key="locationKey"
        >
        </Project-location>

        <ScopesCheckbox v-model:projectScopes="projectInfo.scopes"></ScopesCheckbox>
        <!--ProjectTags v-model:projectTags="projectInfo.tags"></ProjectTags-->
        <TagCreate v-model:projectTags="projectInfo.tags"></TagCreate>
      </template>

      <template v-slot:buttons>
        <div class="btn-footer">
          <FormBtn :name="'Create Project'" @clicked="submitForm"></FormBtn>
          <FormBtn :name="'Cancel'" @clicked="cancel"></FormBtn>
        </div>
      </template>
    </MyForm>
    <p class="debug">projectInfo = {{ JSON.stringify(projectInfo) }}</p>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { MyForm, FormInput, FormTextArea, FormBtn, UserSelect } from '@/components/form'
//import { ProjectSource } from '@/components';
import ProjectDivision  from '@/components/Project-division.vue';
import CustomerListbox  from '@/components/Customer-listbox.vue';
import ScopesCheckbox from '@/components/Project-scopes.vue'
import ProjectLocation from '@/components/Project-location.vue'
import { useProjectStore, useUserStore } from '@/stores'
import TagCreate from '@/components/Tag-create.vue'
import ProjectInvoices from './invoices/Project-invoices.vue';

const userStore = useUserStore()
const projects = useProjectStore()
const locationKey = ref(1) //used to rerender the location component when gps is updated
function reloadLocation() {
  console.log('reloading project location component...')
  locationKey.value += 1
  submitForm()
}
//const customer = ref({id: null, invoiceName: null});
const currUser = userStore.getByEmail(userStore.currentEmail);

const division2 = ref(1);

const projectInfo = ref({
  streetAddress: '',
  city: '',
  province: 'AB',
  description: '',
  notes: '',
  customer: {id: null, invoiceName: null},
  customer_id: null,
  gps: { lat: -1, lon: -1 },
  scopes: [],
  tags: [],
  drafter: null,
  drafter_id: null,
  engineer: userStore.currentEmail,
  engineer_id : currUser.title === 'Engineer' ? currUser.id : null,
  owner: userStore.currentEmail,
  owner_id: currUser.id,
  created_by: userStore.currentEmail,
  //source : '',
  division : { id : 1, name: "SMP-Services"}
  // status: []
})

//create project, hack some dbV2 here
async function submitForm() {
  try {
    console.log('CreateProject.submitForm().')
    console.log(JSON.stringify(projectInfo.value))
    projectInfo.value.customer_id = projectInfo.value.customer.id;
    //projectInfo.value.engineer_id = projectInfo.value.engineer.id;
    await projects.createProject(projectInfo.value)
  } catch (error) {
    console.log(error)
  }
}

function cancel() {
  console.log('CreateProjectView.cancel()...doing nothing')
}

</script>
